<template>
    <div class="collections netflix-style">
        <div class="row" v-for="collection in collections.slice(0, 5) || []" :key="collection.id">
            <h2 class="row-header" @click.stop="$router.push('/videos-colecao/'+collection.url)" style="cursor: pointer;"> 
                <svg @click.stop="$router.push('/videos-colecao/'+collection.url)" style="cursor: pointer;width: 18px;height: 18px;fill: #c4c4c4;margin: 0px 10px 0px 0px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M256 0c-35.3 0-64 28.7-64 64l0 384c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L256 0zM96 72l0 368c0 13.3 10.7 24 24 24s24-10.7 24-24l0-368c0-13.3-10.7-24-24-24s-24 10.7-24 24zM0 120L0 392c0 13.3 10.7 24 24 24s24-10.7 24-24l0-272c0-13.3-10.7-24-24-24S0 106.7 0 120z"/></svg>
              <span>{{collection.comercialName}}</span>
            </h2>
         
            <div class="row-container">
                <swiper
                    :modules="modules"
                    :slides-per-view="mobile ? 1 : 5"
                    :space-between="20"
                    navigation
                    @swiper="onSwiper"
                    @slideChange="onSlideChange"
                >
                    <swiper-slide v-for="slide in collection.lessons" :key="slide.id">
                        <div class="title-card" 
                             @click="toggleModalSubscribe(slide.id, slide.sample, collection.owned, collection.price, collection)"
                             @mouseenter="showPreview(slide)"
                             @mouseleave="hidePreview">
                            <div class="boxart-container">
                                <img v-if="!slide.finalVideoThumbnail" src="@/assets/Weflix/default-video-thumbnail.jpg" alt="Imagem padrão" class="bg-indicator">
                                <img v-else :src="slide.finalVideoThumbnail" :alt="slide.title"/>

                                <!-- <img src="@/assets/gif/LOVEDEATHROBOTSVOLUME4_OfficialTeaser_Netflix-ezgif.com-video-to-gif-converter.gif" alt="GIF" class="gif-indicator"> -->

                                <!-- Preview Box -->
                                <div class="preview-box">
                                    <div class="preview-content">
                                        <p>{{slide.title}}</p>
                                      
                                    </div>
                                </div>
                            </div>
                        </div>
                      
                    </swiper-slide>
                </swiper>
            </div>
        </div>

        <div class="see-more">
            <a href="/colecoes" class="see-more-link" :style="{ backgroundColor: finalWebsite?.color }">
                Ver Coleção Completa
            </a>
        </div>

    </div>
</template>

<script>
import ApiWebsite from '@/utils/Weflix/Website/index';
import ApiCollections from '@/utils/Weflix/collections';
import { mapState, mapActions } from 'vuex';
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/vue';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

export default {
    data(){
        return{
            collections: [],
            titleCollection:['Primeire Coleção', 'Segunda Coleção', 'Terceira Coleção'],
            mobile:false,
            baseUrl: process.env.NODE_ENV === 'development' ? process.env.VUE_APP_BASE_URL_HOMOLOGATION  : window.location.origin,
            breakpoints: {  
                1024: {
                    itemsToShow: 3.6,
                    snapAlign: 'start',
                },
            },
            showPopup: false,
            selectedCollection: null,
            modules: [Navigation, Pagination, Scrollbar, A11y],
            activePreview: null,
            screenWidth: window.innerWidth
        }
    },
    computed:{
        ...mapState(['userPortalWeflix','finalWebsite']),
    },
    methods:{
        ...mapActions(['storeCollectionCheckout']),
        onSwiper(swiper) {
        },
        onSlideChange() {
        },
        showPreview(slide) {
            this.activePreview = slide;
        },
        hidePreview() {
            this.activePreview = null;
        },
        toggleModalSubscribe(id = null, sample = null, owned = null, price = null, collection = null){
            if(this.finalWebsite.company.cartStatus === 0 && price > 0){
                alert('A compra de coleções está desabilitada no momento, tente novamente mais tarde');
                return;
            }

            if(this.userPortalWeflix){
                if(price > 0){
                    if(owned === 4){
                        this.$router.push('/player/'+collection.id);
                    } else {
                        this.setCollectionCheckout(collection);
                        this.showPopup = true;
                    }
                } else {   
                    if(this.userPortalWeflix.user.orderStatus === 1 || sample === 1){ 
                        this.$router.push('/player/'+id)
                    } else {
                        this.$emit('toggleOpenSubscribe');
                    }
                }
            } else {
                if(price > 0){
                    this.setCollectionCheckout(collection);
                        this.showPopup = true;
                    } else {
                        this.$emit('toggleOpenDialog');
                    }
            }
        },
        setCollectionCheckout(collection) {
              this.storeCollectionCheckout({collectionCheckout: collection});
        },
        async getCollections(){
            const aux = this.baseUrl.replace(/\/$/, '');
          
            const payload = {
                "url": aux
            }
            try {
                const response = await ApiWebsite.getCollectionsLimit(payload, 0);
                this.collections = response.content.sort((a, b) => a.order - b.order);
                console.debug(response);
            } catch (error) {
                console.error(error);
            }
        },
        async getCollectionByLogin(){
            try {
                const response = await ApiCollections.getCollectionByLogin(this.userPortalWeflix.acessToken);
                this.collections = response.content.sort((a, b) => {
                    if (a.owned !== b.owned) {
                        return b.owned - a.owned;
                    }
                    return a.order - b.order;
                });
                console.debug(this.collections);
            } catch (error) {
                console.error(error);
            }
        },

        itemsToShow(itemCount) {
            if (this.mobile) return 1;
            return itemCount === 1 ? 1 : Math.min(itemCount, 3.6);
        },
        shouldWrapAround(itemCount) {
            return !this.mobile && itemCount > 1;
        },
        snapAlign(itemCount) {
            if (this.mobile || itemCount === 1) return 'center';
            return 'start';
        },
        handleResize() {
            this.mobile = window.innerWidth <= 768;
        },
        formatarTempo(tempo) {
            const horas = Math.floor(tempo / 3600);
            const minutos = Math.floor((tempo % 3600) / 60);
            return `${horas > 0 ? horas + 'h ' : ''} ${minutos > 0 ? minutos + 'm' : ''}`;
        },
       
        closePopup() {
            this.showPopup = false;
        },
        confirmPurchase() {
            if(this.userPortalWeflix){
                this.$router.push('/checkoutweflix');
            } else {
                this.$emit('toggleOpenDialog');

                this.closePopup();
            }
        },
        redirectToCheckout(){
            this.$router.push('/checkout-collection-weflix');
        }
    },
    created(){
        this.screenWidth = window.innerWidth;
        if(this.userPortalWeflix){
            this.getCollectionByLogin();
        }else{
            this.getCollections();
        }
        this.mobile = window.innerWidth <= 768;
        window.addEventListener('resize', this.handleResize);
    },
    unmounted() {
        window.removeEventListener('resize', this.handleResize);
    },
    components: {
        Swiper,
        SwiperSlide
    },
    emits: ['toggleOpenSubscribe', 'toggleOpenDialog']
}
</script>

<style scoped>
.netflix-style {
    padding: 20px 0;
}

.row {
    margin-bottom: 40px;
}

.row-header {
    font-size: 15px;
    color: #acacac;
    font-weight: 700;
    margin: 0 0% .5em 0%;
    text-align: left;
    margin-bottom: 15px;
}

.row-container {
    position: relative;
    padding: 0%;
}

.title-card {
    position: relative;
    cursor: pointer;
    transition: transform 0.3s;
}

.title-card:hover {
    transform: scale(1.05);
    z-index: 2;
}
.title-card:hover .preview-box {
    box-shadow: 0px 0px 30px 15px rgb(0 0 0);
}
.boxart-container {
    position: relative;
    width: 100%;
    height: 0;
    padding-top: 56.25%;
}

.boxart-container img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 4px;
}
.title-card:hover .preview-box {
    transform: translate(0px, -3px);
    width: 96%;
    padding-left: 10px;
    opacity: 1;
}
.preview-box {
    transition: all 0.3s ease 0s;
 position: absolute;
    bottom: 0px;
    /* left: 50%; */
    /* transform: translateX(-50%); */
    width: 100%;
    background: rgba(0, 0, 0, 0.9);
    padding: 0;
    padding: 5px 5px;
    z-index: 10;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
    opacity: 0;
    transform: translate(0px, 29px);
}

.preview-content {
      color: white;
    text-align: left;
}
.preview-content p {
    font-size: 12px;
    margin: 0;
}
.preview-content h4 {
    margin: 0 0 8px 0;
    font-size: 14px;
    font-weight: 600;
}

.preview-metadata {
    display: flex;
    gap: 8px;
    font-size: 12px;
    margin-bottom: 8px;
}

.preview-duration {
    color: #999;
}

.preview-category {
    background: rgba(255, 255, 255, 0.2);
    padding: 2px 6px;
    border-radius: 3px;
}

.preview-description {
    font-size: 12px;
    margin: 0;
    line-height: 1.3;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.lock-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,0.7);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: white;
}

.sample-badge {
    position: absolute;
    top: 10px;
    right: 10px;
    background: #e50914;
    color: white;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
}

.collection-cta, .collection-actions {
    margin: 20px 4%;
    display: flex;
    align-items: center;
    gap: 20px;
}

.cta-button, .primary-button {
    padding: 12px 24px;
    border: none;
    border-radius: 4px;
    color: white;
    font-weight: 600;
    cursor: pointer;
}

.secondary-button {
    padding: 12px 24px;
    background: transparent;
    border: 2px solid white;
    color: white;
    border-radius: 4px;
    cursor: pointer;
}

.see-more {
    text-align: center;
    padding: 20px 0;
}

.see-more-link {
    display: inline-block;
    padding: 12px 24px;
    color: white;
    text-decoration: none;
    border-radius: 4px;
}

.modal {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}

.modal-content {
    background: #181818;
    padding: 30px;
    border-radius: 6px;
    max-width: 500px;
    width: 90%;
    color: white;
}

.modal-actions {
    display: flex;
    gap: 10px;
    margin-top: 20px;
}

@media (max-width: 768px) {
    .row-header {
        font-size: 15px;
    }
    
    .collection-cta, .collection-actions {
        flex-direction: column;
    }

    .preview-box {
        width: 160px;
        bottom: -70px;
    }
}

element.style {
    font-size: 11px;
}
.bg-indicator {
    display: block;
    opacity: 1;
    transition: all 0.3s ease 0s;
}
.title-card:hover .bg-indicator {
    opacity: 0;
    display: none;
}

.gif-indicator {
    opacity: 0;
    display: none;
    transition: all 0.3s ease 0s;
}
.title-card:hover .gif-indicator {
    opacity: 1;
    display: block;
}
</style>
<style>
.videoCollections.pageCollections .swiper-slide .carousel__item img {
    height: 100%;
    margin-top: 20px;
    border-radius: 5px !important;
}
.layout-Netflix {
    position: relative;
    /* max-width: 1500px; */
    /* margin: 0 auto; */
    transform: translateY(-100px);
    z-index: 11;
    background-color: black;
    background: #ffffff;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(0, 0, 0, 0.4) 10%, rgba(0, 0, 0, 1) 100%);
}
.collections.netflix-style {
    position: static;
    max-width: 1500px;
    margin: 0 auto;
    /* transform: translateY(-200px); */
    z-index: 12;
    position: initial;
}
    
    .collections {
        background-color: transparent !important;
    }
    @media (max-width: 600px) {
        .collections.netflix-style {
            position: static;
            max-width: 1500px;
            margin: 0 auto;
            transform: translateY(90px);
            z-index: 12;
            position: initial;
            padding: 25px;
        
        }
    }
</style>    